import { render } from "./Rimborsi.vue?vue&type=template&id=734315da&scoped=true&ts=true"
import script from "./Rimborsi.vue?vue&type=script&lang=ts"
export * from "./Rimborsi.vue?vue&type=script&lang=ts"

import "./Rimborsi.vue?vue&type=style&index=0&id=734315da&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734315da"]])

export default __exports__